<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">{{ $t("EaaShops.Store_List") }}</h4>
              </div>
              <div class="card-body">
                <!-- <router-link v-if="userType === 'si'" to="./eaa-accounts/new" type="success">
                  <n-button type="success">建立 EAA 帳號與管理員</n-button>
                </router-link> -->

                <el-row style="margin-bottom: 10px">
                  <el-col :span="5">
                    <el-input v-model="filters[0].value" :placeholder="$t('EaaShops.Search')"></el-input>
                  </el-col>
                </el-row>

                <!-- <data-tables :data="data" :filters="filters" :action-col="actionCol"> -->
                <data-tables :data="data" :filters="filters">
                  <el-table-column
                    v-for="title in titles"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.prop"
                    sortable="custom"
                  ></el-table-column>
                  <el-table-column :label="$t('EaaShops.Action')" min-width="100px">
                    <template slot-scope="scope">
                      <el-button
                        v-for="button in customButtonsForRow(scope.row)"
                        :key="button.name"
                        @click="button.handler"
                      >{{ button.name }}</el-button>
                    </template>
                  </el-table-column>
                </data-tables>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      data: [],
      // actionCol: {
      //   label: "操作",
      //   props: {
      //     align: "center"
      //   },
      //   buttons: [
      //     {
      //       props: {
      //         type: "default",
      //         icon: "el-icon-edit"
      //       },
      //       label: "授權給此店家",
      //       handler: row => {
      //         console.log("the row is ", row);
      //         this.assignShopToEaa(row.id);
      //       }
      //     }
      //   ]
      // },
      filters: [
        {
          value: "",
          prop: ["id", "name", "eaaAccount"]
        },
        {
          value: []
        }
      ]
    };
  },
  computed: {
    titles() {
      return [
        {
          prop: "id",
          label: this.$t('EaaShops.Number')
        },
        {
          prop: "name",
          label: this.$t('EaaShops.Name')
        },
        {
          prop: "eaaAccount",
          label: this.$t('EaaShops.Current_Store')
        },
        {
          prop: "status",
          label: this.$t('EaaShops.Active')
        },
        {
          prop: "createdAt",
          label: this.$t('EaaShops.Creation_Time')
        },
        {
          prop: "updatedAt",
          label: this.$t('EaaShops.Update_Time')
        }
      ]
    },
    userType: function() {
      return this.$store.getters.userType;
    }
  },
  methods: {
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    customButtonsForRow(row) {
      
      if (row.eaaId == this.$route.params.eaaId) {
        return [];
      } else {
        return [
          {
            name: this.$t("EaaShops.Message.Authorize"),
            handler: _ => {
              this.assignShopToEaa(row.id);
            }
          }
        ];
      }
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      // var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        message:message,
        timeout: 300000,
        icon: 'now-ui-icons ui-1_bell-53',
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        title: type,
        type: type
      });
    },
    assignShopToEaa(shopId) {
      return axios
        .post(
          `${process.env.VUE_APP_APIHOST}/${this.userType}/eaa-accounts/${this.$route.params.eaaId}/shops`,
          { shopId: shopId }
        )
        .then(response => {
          console.log("the response " + JSON.stringify(response.data));
          // this.data = response.data;
          // for (let a of this.data) {
          //   a.createdAt = a.createdTs
          //     ? moment.unix(a.createdTs).format("YYYY-MM-DD HH:mm:ss Z")
          //     : "";
          //   a.updatedAt = a.updatedTs
          //     ? moment.unix(a.updatedTs).format("YYYY-MM-DD HH:mm:ss Z")
          //     : "";
          // }
          this.getAllShops();
          this.notifyVue('top', 'right', 'success', this.$t("EaaShops.Message.Authorization_successful"));
          return response.data;
        })
        .catch(e => {
          console.log('assign failed ', e);
          let message = this.$t("EaaShops.Message.Authorization_failed");
          try {
            let a = JSON.parse(e.data);
            message = a.message;
          } catch (err) {

          }
          this.notifyVue('top', 'right', 'error', message);
        });
    },
    getAllShops() {
      return axios
        .get(`${process.env.VUE_APP_APIHOST}/${this.userType}/shops`)
        .then(response => {
          console.log("the response " + JSON.stringify(response.data));
          this.data = response.data;
          for (let a of this.data) {
            a.createdAt = a.createdTs
              ? moment.unix(a.createdTs).format("YYYY-MM-DD HH:mm:ss Z")
              : "";
            a.updatedAt = a.updatedTs
              ? moment.unix(a.updatedTs).format("YYYY-MM-DD HH:mm:ss Z")
              : "";
            a.status = a.isEnabled ? this.$t("EaaShops.Active") : this.$t("EaaShops.Stop");
          }
          return response.data;
        });
    }
  },
  mounted() {
    this.getAllShops();
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
.card .alert {
  position: relative !important;
  width: 100%;
}
</style>
